import { languageService } from "../../../Language/language.service";
import { dataFormatters } from "../../../utils/dataFormatters";
export const MissedAssetTestReportSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
      },
      minDataRowsCount: 5,
      columns: [
        {
          title: languageService("Tests"),
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "title",
        },
        {
          title: languageService("Date"),
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "expiryDate",
          formatter: dataFormatters.dateFormatter,
        },
        {
          title: languageService("Status"),
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "status",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/MissedInspections/MissedAssetTestReportSchema.js